/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(function () {
	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery(".accordion p:empty, .orbit p:empty").remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(
		function () {
			if (jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5) {
				jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
			} else {
				jQuery(this).wrap("<div class='responsive-embed'/>");
			}
		}
	);
});

/* jQuery("a")
	.filter(function () {
		return this.hostname && this.hostname !== location.hostname;
	})
	.addClass("link--external"); */

    jQuery(".footerinfo a")
	.filter(function () {
		return this.hostname && this.hostname !== location.hostname;
	})
	.addClass("externallink")
	.append(`
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M384 64c-17.7 0-32 14.3-32 32s14.3 32 32 32h82.7L265.3 329.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L512 173.3V256c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-240 96c-44.2 0-80 35.8-80 80v256c0 44.2 35.8 80 80 80h256c44.2 0 80-35.8 80-80v-80c0-17.7-14.3-32-32-32s-32 14.3-32 32v80c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16h80c17.7 0 32-14.3 32-32s-14.3-32-32-32z"/></svg>
	`);